import { useTranslation } from "react-i18next";

import { Card, Message, Overlay, Spinner } from "./DownloadingOverlay.styles";

// EN-4852: full-screen downloading state shown while the spirometry session PDF
// is being generated by the backend.

type DownloadingOverlayProps = {
  message?: string;
};

export function DownloadingOverlay({ message }: DownloadingOverlayProps) {
  const { t } = useTranslation();

  return (
    <Overlay>
      <Card>
        <Spinner />
        <Message>
          {message ?? t("patientPage_measurementModal_downloadingReport")}
        </Message>
      </Card>
    </Overlay>
  );
}
